// extracted by mini-css-extract-plugin
export default {"EditColum":"EditColum_EditColum__LOlWO","EditColumImg":"EditColum_EditColumImg__oDNAo","Overlay":"EditColum_Overlay__-dGBr"};